import "./scss/blog-denim-zero.scss"
import 'swiper/swiper-bundle.css'

import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import { isDev } from "@/utils/enviroment-detector"
import type { BlogAppProps } from "../../../types/blog.props"

export function BlogDenimZero({ ultimasPostagens, width, height }: Readonly<BlogAppProps>) {
    return (
        <Swiper
            modules={[Navigation]}
            breakpoints={{
                0: { slidesPerView: 1 },
                700: { slidesPerView: 2 },
                1000: { slidesPerView: 3 },
            }}
            navigation={{
                prevEl: ".dicas-de-moda .swiper-button-prev",
                nextEl: ".dicas-de-moda .swiper-button-next",
            }}
            rewind={true}
            className="dicas-de-moda container"
            wrapperClass="lista-dicas flex"
        >
            {ultimasPostagens.map((materia) => (
                <SwiperSlide key={materia.id}>
                    <a href={materia.url} title={materia.titulo}>
                        <img
                            className="imagem-principal lazyload"
                            src={materia.url_hint_blog || ""}
                            data-src={materia.url_midia_blog}
                            title={materia.midia_alt}
                            alt={materia.midia_alt}
                            width={width > 0 ? width : 363}
                            height={height > 0 ? height : 152}
                        />
                    </a>
                    <h2>{materia.titulo}</h2>

                    <div className="dados-postagem flex justify-center">
                        <div title="Data de postagem" className="flex center">
                            <img
                                className="lazyload lazyload-svg"
                                src={isDev() ? getResourceFromS3("assets/global/blog", "icon-calendar.svg") : materia.url_hint_blog}
                                data-src={getResourceFromS3("assets/global/blog", "icon-calendar.svg")}
                                width={14}
                                height={14}
                                alt="Calendar"
                                title="Calendar"
                            />

                            <p>{new Date(materia.data_criacao).toLocaleDateString("pt-BR")}</p>
                        </div>

                        <div title="Categoria" className="flex center">
                            <img
                                className="lazyload lazyload-svg"
                                src={isDev() ? getResourceFromS3("assets/global/blog", "icon-calendar.svg") : materia.url_hint_blog}
                                data-src={getResourceFromS3("assets/global/blog", "icon-tag.svg")}
                                width={14}
                                height={14}
                                alt="Categoria"
                                title="Categoria"
                            />

                            <p>{materia.cat_nome}</p>
                        </div>
                    </div>
                    <a href={materia.url} title="Saiba mais" className="shop-now">
                        Saiba mais
                    </a>
                </SwiperSlide>
            ))}

            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
        </Swiper>
    )
}

export default class BlogDenimZeroApp {
    constructor(props: BlogAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<BlogDenimZero {...props} />)
    }
}